<ng-container *transloco="let t; read: 'user'">
  @if (studentInfo) {
    <div>
      @for (domain of studentDomains; track domain) {
        <div class="flex flex-col mt-5">
          <drdp-container additionClasses="min-h-[10rem]">
            <div class="md:flex place-content-between place-items-center self-center">
              <div class="font-semibold text-xl">
                <img [ngClass]="{
                  'domain-icon': !studentInfo?.is2025Enrollment,
                  'domain-icon-2025-core': studentInfo?.is2025Enrollment && isCoreDomain(domain.domainCode),
                  'domain-icon-2025-supplemental': studentInfo?.is2025Enrollment && !isCoreDomain(domain.domainCode)
                }" src="assets/images/domains/{{domain.iconName}}" [alt]="domain.domainCode">
                <!-- Domain code and name are server-supplied: localized by the API, not by Transloco. -->
                {{domain.domainCode}} - {{domain.domainName}}
              </div>
              <div class="flex justify-end items-end text-xl">
                {{domain.domainTotal}}
              </div>
            </div>
            <div class="grid grid-cols-1  md:grid-cols-3 gap-4 mb-4">
              @for (measure of domain.measures; track measure) {
                <div class="mt-5 px-1 flex flex-col">
                  <div class="flex-grow">
                    <!-- Measure code and name are server-supplied. -->
                    <h2 class="font-semibold ml-2">{{ measure.code }} : {{ measure.name }}</h2>
                  </div>
                  <div class="mt-3 justify-end">
                    <input class="bg-transparent py-1 px-2 border border-gray-900 w-2/4 placeholder-black" [attr.aria-label]="t('inputRating.ratingCard.ratingSelectedLabel')"
                      [placeholder]="measure.selectedLevelName ?? t('inputRating.ratingCard.noneSelected')" [id]="measure.id" type="text" readonly>
                    @if (!measure.preRatingValue && !measure.ratingValue && !measure.measureConditionId) {
                      <button
                        class="bg-transparent text-blue-700 font-semibold py-1 px-4 border border-blue-500"
                        [disabled]="!canCreateRating || isRatingDisabled"
                        (click)="selectRating(domain,measure)">{{ t('inputRating.ratingCard.selectRating') }}</button>
                    }
                    @if (measure.preRatingValue && !measure.ratingValue && !measure.measureConditionId) {
                      <button
                        class="bg-sky-500 text-blue-950 font-semibold py-1 px-4 border border-sky-500"
                        [disabled]="!canCreateRating || isRatingDisabled"
                      (click)="selectRating(domain,measure)">{{ t('inputRating.ratingCard.reviewPreRating') }}</button>
                    }
                    @if (measure.ratingValue || measure.measureConditionId) {
                      <button
                        [ngClass]="{'cursor-not-allowed': studentInfo.isLocked || isRatingDisabled}"
                        [disabled]="!canCreateRating || isRatingDisabled || studentInfo.isLocked"
                        class="bg-blue-900 text-blue-50 py-1 px-4 border border-blue-900"
                        (click)="selectRating(domain, measure)">{{ t('inputRating.ratingCard.finalRating') }}</button>
                    }
                  </div>
                  @if ((measure.ratingValue || measure.measureConditionId) && !studentInfo.isLocked && isFieldStudy) {
                    <a
                      class="text-drdpblue-300 underline pt-1 cursor-pointer" (click)="editTeacherSurvey(measure)">
                      {{ t('inputRating.ratingCard.editSurveyResponse') }}
                    </a>
                  }
                  @if ((measure.ratingValue || measure.measureConditionId) && studentInfo.isLocked && isFieldStudy) {
                    <a
                      class="text-drdpgrey-200 underline pt-1 cursor-pointer" (click)="viewTeacherSurvey(measure)">
                      {{ t('inputRating.ratingCard.viewSurveyResponse') }}
                    </a>
                  }
                </div>
              }
            </div>
          </drdp-container>
        </div>
      }
    </div>
  }
</ng-container>
